'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = loading;

var _store = require('redux-connect/lib/store');

var _presentation = require('../actions/presentation');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
  orderSummaryVisible: true,
  addressBookVisible: false,
  addressBookPage: 'AddressList',
  addressBookType: null,
  addressBookEditId: null,
  clickAndCollect: false,
  pickupLocatorVisible: false,
  checkoutHelpVisible: false,
  selectedAddressIds: {
    billing: null,
    shipping: null
  }
};

function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _presentation.SHOW_ORDER_SUMMARY:
      return (0, _extends3.default)({}, state, { orderSummaryVisible: true });
    case _presentation.HIDE_ORDER_SUMMARY:
      return (0, _extends3.default)({}, state, {
        orderSummaryVisible: false,
        addressBookVisible: false
      });
    case _presentation.SET_CLICK_AND_COLLECT:
      return (0, _extends3.default)({}, state, { clickAndCollect: action.enable });
    case _presentation.SHOW_PICKUP_LOCATOR:
      return (0, _extends3.default)({}, state, { pickupLocatorVisible: true });
    case _presentation.HIDE_PICKUP_LOCATOR:
      return (0, _extends3.default)({}, state, { pickupLocatorVisible: false });
    case _presentation.SHOW_CHECKOUT_HELP:
      return (0, _extends3.default)({}, state, { checkoutHelpVisible: true });
    case _presentation.HIDE_CHECKOUT_HELP:
      return (0, _extends3.default)({}, state, { checkoutHelpVisible: false });
    case _presentation.SHOW_CHECKOUT_NOTICE:
      return (0, _extends3.default)({}, state, { checkoutInfoVisible: true });
    case _presentation.HIDE_CHECKOUT_NOTICE:
      return (0, _extends3.default)({}, state, { checkoutInfoVisible: false });
    case _store.END_GLOBAL_LOAD:
      return (0, _extends3.default)({}, state, {
        orderSummaryVisible: false
      });
    case 'SHOW_ADDRESS_BOOK':
      return (0, _extends3.default)({}, state, {
        addressBookVisible: true,
        addressBookPage: 'AddressList',
        addressBookType: action.addressBookType
      });
    case 'HIDE_ADDRESS_BOOK':
      return (0, _extends3.default)({}, state, { addressBookVisible: false });
    case 'SET_ADDRESS_BOOK_PAGE':
      return (0, _extends3.default)({}, state, { addressBookPage: action.page });
    case 'SET_CHOSEN_ADDRESS':
      {
        var newState = {
          selectedAddressIds: {
            billing: state.selectedAddressIds.billing,
            shipping: state.selectedAddressIds.shipping
          }
        };

        newState.selectedAddressIds[action.addressType] = action.addressId;

        return (0, _extends3.default)({}, state, { selectedAddressIds: newState.selectedAddressIds });
      }
    case 'EDIT_ADDRESS':
      return (0, _extends3.default)({}, state, {
        addressBookPage: 'EditAddress',
        addressBookEditId: action.addressId
      });
    case 'SELECT_PAYMENT_OPTION':
      return (0, _extends3.default)({}, state, { selectedPaymentOptionId: action.paymentOptionId });
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/reducers/presentation.js
// module id = 2537
// module chunks = 0